<template>
	<div id="summary">
		<v-container v-if="!loading">
			<v-row>
				<div class="col-md-12 col-sm-12">
					<v-alert
                      v-if="signed"
                      text
                      class="signed-alert"
                      :style="{ backgroundColor: elementColor, color: elementTextColor }"
                      role="status"
                      aria-live="polite"
                    >
                      <!-- icono de check al inicio -->
                      <v-icon left class="signed-alert__icon" aria-hidden="true">mdi-checkbox-marked-circle-outline</v-icon>
                      {{ summaryMessage }}
                    </v-alert>
                    <v-alert
                      v-if="rejected"
                      text
                      class="reject-alert"
                      :style="{ backgroundColor: elementColor, color: elementTextColor }"
                      role="status"
                      aria-live="polite"
                    >
                      <!-- icono de check al inicio -->
                      <v-icon left class="signed-alert__icon" aria-hidden="true">mdi-close-outline</v-icon>
                      {{ summaryMessage }}
                    </v-alert>

				</div>
			</v-row>

			<!-- CUSTOMER ALERT / CARD -->
			<div id="customer-alert">
				<v-card outlined class="pa-1">
					<v-row>
						<div class="col-md-12 col-xs-12">
							<v-list two-line>
								<v-list-item background-color="white">
									<v-list-item-content>
										<v-list-item-title class="mb-1">
											<h3>{{ title }}</h3>
										</v-list-item-title>
										<v-list-item-subtitle class="color_gray--text font-weight-medium">
											{{ signatureTransactionData.ownerName }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item class="px-0">
                                   <h4 class="ma-0">{{ $t("signers") }}</h4>
                                   <v-avatar :color="elementColor" class="ml-2" size="16">
                                      <span :style="{ color: elementTextColor }" style="font-size: 10px;">{{ signatureCount }}</span>
                                   </v-avatar>
                                </v-list-item>
							</v-list>
						</div>
					</v-row>

					<!-- lista de firmantes -->
					<v-row>
						<div class="col-md-4 col-sm-12 signer-col" v-for="(item, index) in signatureRequestList" :key="index">
                           <v-list class="pa-0" flat>
                              <v-list-item class="pa-0" style="min-height: 40px;">

                                 <v-list-item-icon class="ml-0 mr-3 my-2">
                                    <v-icon v-if="item.status === 'SIGNED' || item.status === 'PRESIGNED'"
                                            :color="getIconColorByStatus('SIGNED')">
                                       mdi-checkbox-marked-circle-outline
                                    </v-icon>
                                    <v-icon v-else-if="item.status === 'REJECTED'"
                                            :color="getIconColorByStatus('REJECTED')">
                                       mdi-close-outline
                                    </v-icon>
                                    <v-icon v-else :color="getIconColorByStatus('NOTIFIED')">
                                       mdi-clock
                                    </v-icon>
                                 </v-list-item-icon>

                                 <v-list-item-content class="pa-0">
                                    <v-list-item-subtitle class="color_gray--text font-weight-medium black--text">
                                       {{ item.name }}
                                    </v-list-item-subtitle>
                                    <small class="grey--text">{{ moment(item.date).format("DD/MM/YYYY HH:mm") }}</small>
                                 </v-list-item-content>

                              </v-list-item>
                           </v-list>
                        </div>

					</v-row>

					<!-- <-- AQUI: alertas homogéneas agrupadas dentro del card -->
					<v-row class="mt-3">
						<v-col cols="12">
							<div class="alerts-container">

								<!-- botón de descarga o alerta en su lugar -->
								<div class="text-center">
									<v-btn
                                      v-if="showDownloadButton"
                                      class="download-btn"
                                      :style="{ backgroundColor: elementColor, color: elementTextColor }"
                                      large
                                      :loading="loadingDownload"
                                      :disabled="loadingDownload"
                                      @click="handleDownload"
                                    >
                                      <v-icon left :style="{ color: elementTextColor }">mdi-download</v-icon>
                                      {{ $t('download') }}
                                    </v-btn>

									<v-alert
                                      v-else
                                      class="homogeneous-alert mt-2"
                                      dense
                                      text
                                      :value="true"
                                      :style="{ backgroundColor: (elementColor ? elementColor + '20' : 'transparent'), color: 'black' }"
                                      role="status"
                                      aria-live="polite"
                                    >
                                      {{ $t("doc_downloadable_message") }}
                                    </v-alert>
								</div>

								<!-- alerta de on-copy (si aplica) -->


							</div>
						</v-col>
					</v-row>

				</v-card>
			</div>
            <v-alert
              v-if="showOnCopyMessage"
              dense
              :value="true"
              :style="{ backgroundColor: (elementColor ? elementColor + '20' : 'transparent'), color: 'black' }"
              icon="mdi-email"
              role="status"
              aria-live="polite"
            >
              {{ $t('oncopy_message') }}
              <strong v-if="signerEmail" class="oncopy-email"> {{ signerEmail }} </strong>
            </v-alert>
            <!-- eliminado: filas inferiores duplicadas de alerts (ya están dentro del card) -->

			<!-- ✅ Mostrar el texto solo si localStorage.list es "true" -->
            <template>
              <v-row justify="center" v-if="showBackToList">
                <v-col cols="auto">
                  <v-btn text @click="isLogging" class="d-flex align-center">
                    <v-icon class="mr-2">mdi-home</v-icon>
                    <span>Volver a la lista de documentos</span>
                  </v-btn>
                </v-col>
              </v-row>
            </template>

			<v-row>
                <div class="col-md-12 col-xs-12 mt-1">
                    <!-- Mantenemos el custom-alert original -->
                    <v-alert
                      dark
                      icon="false"
                      prominent
                      :style="{ backgroundColor: elementColor }"
                      class="d-flex align-start custom-alert"
                    >
                      <!-- Icono personalizado -->
                      <template v-slot:prepend>
                        <img
                          src="@/assets/isotipo-escudo-ajustado.svg"
                          alt="PortaSigma"
                          class="custom-alert-icon"
                        />
                      </template>

                      <!-- Contenido -->
                      <div class="custom-alert-content" :style="{ color: elementTextColor }">
                        {{ summaryText }}
                        <p class="custom-alert-link">
                          <a
                            href="https://www.portasigma.com/"
                            target="_blank"
                            class="footer-link"
                            rel="noopener"
                            :style="{ color: elementTextColor }"
                          >
                            {{ associationPresent ? 'Powered by PortaSigma' : 'https://www.portasigma.com' }}
                          </a>
                        </p>
                      </div>
                    </v-alert>

                </div>
			</v-row>
		</v-container>

		<!-- loader -->
		<v-container style="height: 400px" v-if="loading">
			<v-row class="fill-height" align-content="center" justify="center">
				<v-col class="subtitle-1 text-center" cols="12">
					{{ $t("please_wait") }} ....
				</v-col>
				<v-col cols="6">
					<v-progress-linear :color="elementColor" indeterminate rounded height="6"></v-progress-linear>
				</v-col>
			</v-row>
		</v-container>
    </div>
</template>

<script>
import { SignaturesService } from "../services/signatures-service";

import moment from "moment";
export default {
	name: "important-information",
	props: {
		showMessage: String,
		item: { type: Object, default: null }, // antes: required: true

	},
	data: function () {
		return {
			documentId: 2406330,
			appendFils: false,
			title: "",
			document: [],
			signatureTransactionData: [],
			signatureRequestList: [],
			signatureCount: 0,
			requestId: localStorage.getItem("request_id"),
			transactionId: localStorage.getItem("transaction_id"),
			loading: false,
			loadingDownload: false,
			authId: localStorage.getItem("auth_id"),
			hasPendingSigners: false,
			userToken: localStorage.getItem("auth_user_token"),
			associationText: "",
			signerEmail: "",
			onCopyRequests: [],
			aggregatedStatus: 0,
			requestStatus: 0
		};
	},

	created: function () {
		this.moment = moment;
			},

	computed: {


         elementColor() {
                     return this.$store.state.common.footerColor;
                 },

         showDownloadButton () {
               return this.signatureTransactionData?.aggregatedStatus === "3"
         },

         showOnCopyMessage() {
           // sólo mostrar cuando el requestStatus (o el fallback) sea SIGNED
           const status = (
             (this.requestStatus || (this.signatureTransactionData && this.signatureTransactionData.status) || '')
           ).toString().toUpperCase();

           if (status !== 'SIGNED') return false;

           // normalizar objetivo
           const target = (this.signerEmail || '').trim().toLowerCase();
           if (!target) return false;

           // proteger por si onCopyRequests no es array
           const list = Array.isArray(this.onCopyRequests) ? this.onCopyRequests : [];

           // ¿hay match? -> boolean
           return list.some(entry =>
             ((entry && entry.signerEmail) || '').trim().toLowerCase() === target
           );
         },


         summaryMessage() {
             // prioridad a this.requestStatus, fallback a signatureTransactionData.status
             const status = (
               (this.requestStatus || (this.signatureTransactionData && this.signatureTransactionData.status) || '')
             ).toString().toUpperCase();

             if (status === 'SIGNED') {
               return this.$t('doc_signed_correctly') || 'Documento firmado correctamente';
             }

             if (status === 'REJECTED') {
               return this.$t('petition_rejected_full') ||
                 'Petición de firma rechazada. Si deseas firmarla puedes acceder de nuevo a través del enlace de firma que has recibido';
             }

             // si no hay estado conocido, no mostramos mensaje
             return '';
           },

         signed() {
              // prioridad a this.requestStatus, fallback a signatureTransactionData.status
              const status = (
                (this.requestStatus || (this.signatureTransactionData && this.signatureTransactionData.status) || '')
              ).toString().toUpperCase();

              if (status === 'SIGNED') {
                return true;
              } else
              {
                return false;
              }
         },

         rejected() {
               // prioridad a this.requestStatus, fallback a signatureTransactionData.status
               const status = (
                 (this.requestStatus || (this.signatureTransactionData && this.signatureTransactionData.status) || '')
               ).toString().toUpperCase();

               if (status === 'REJECTED') {
                 return true;
               } else
               {
                 return false;
               }
          },

         associationPresent() {
            const raw = this.$store.state.common.associationText
            return typeof raw === 'string' && raw.trim().length > 0
          },

        summaryText() {
            const txt = (this.$store.state.common.associationText || '').trim()
            return txt ? txt : this.$t('summary_msg')
          },

        hasAssociation() {
                return this.$store.getters['common/hasAssociation']
            },

        showBackToList() {
            let back;
            let user = localStorage.getItem("user");
            let list = localStorage.getItem("list");
            if (user || list) {
                back = true;
                }
            else {
                back = false;
                }
            return back;
        },



        elementTextColor() {
            return this.$store.state.common.footerTextColor;
        }
    },

	mounted() {
		console.log("elementColor:", this.elementColor);
        console.log("elementTextColor:", this.elementTextColor);
        console.log("Asociación en Summary: " + localStorage.getItem('currentAssociation'));
        this.associationText = this.$store.state.common.associationText;
        console.log("Texto de Asociación: ", this.associationText);
		this.loadRequestData();
			},

	methods: {

           handleDownload() {
               // req_Evidences devuelve un flag que es verdadero cuando la petición es para nuevo Frontend
               // y a partir de la fecha en la que se empiezan a registrar todos los eventos.
                 this.loadingDownload = true; // Activa el loader por defecto
                 const hasEvidences = this.document?.req_evidences === true;
                 const isNotHuman = this.document?.type !== "HUMAN";

                 console.log("Has evidences", hasEvidences);
                 console.log("Is not Human", isNotHuman);

                 if (hasEvidences && isNotHuman) {
                    this.downloadReqEvidencesDocument();
                 } else {
                    this.downloadSignatureRequestDocument();
                 }
              },


           isLogging() {
                        this.authid="";
                        let association=localStorage.getItem("currentAssociation");
                        let isCustomized=localStorage.getItem("isCustomizedUser");
                        console.log("asociación dentro de summary:" + association);
                        console.log(localStorage.getItem("auth_user_token"));

                        if (localStorage.getItem("auth_user_token") != null) {
                            this.$router.push({
                                name: isCustomized ? "custom-my-signatures" : "my-signatures",
                                params: isCustomized ? { association } : {}
                            });

                        } else {
                            // Si no hay authCitizenId, redirigir directamente a DocumentList
                            console.log("Hay asociación?" + this.hasAssociation);
                            const routeName = this.hasAssociation ? "custom-multiple-pdf" : "multiple-pdf";
                            this.$router.push({ name: routeName });
                            console.log(this.authCitizenId);
                        }
                    },

		changeAppendFileShow() {
			this.appendFils = !this.appendFils;
		},

		loadRequestData() {
			if (this.requestId) {
				this.loading = true;
				SignaturesService.getSignatureRequestData(this.requestId, this.authId)
					.then((response) => {
						this.signatureTransactionData = response.data.signatureTransaction;
						this.document = response.data;
						this.title = this.signatureTransactionData.description;
						this.signerEmail = response.data.signerEmail;
						this.requestStatus = response.data.status;
						this.onCopyRequests = Array.isArray(this.signatureTransactionData.onCopyRequests)
                                                        ? [...this.signatureTransactionData.onCopyRequests]
                                                        : []

						console.log('signerEmail: ' + this.signerEmail);
						console.log('onCopyRequests =', JSON.stringify(this.onCopyRequests, null, 2))
						this.createRequestList(response.data);
						this.loading = false;
						localStorage.setItem("file_name", this.signatureTransactionData.document.filename);
					})
					.catch((error) => {
						console.log(error);
						this.loading = false;
					});
			}
		},

		createRequestList(data) {
			var vm = this;
			vm.signatureRequestList.push({
				name: data.signerName,
				date: data.dateAction,
				status: data.status,
				comments: data.comments,
			});

			if (data.signatureTransaction.signatureRequests.length > 1) {
				vm.hasPendingSigners = false;
				data.signatureTransaction.signatureRequests.map(function (item) {
					if (item.signerName && item.signerName !== "") {
						vm.signatureRequestList.push({
							name: item.signerName,
							date: item.dateAction,
							status: item.status,
							comments: item.comments,
						});

						if (item.status == 'NOTIFIED') {
							vm.hasPendingSigners = true
						}
					}
				});
			}
			this.signatureCount = this.signatureRequestList.length;
		},

		downloadSignatureRequestDocument() {
			if (this.transactionId) {
				this.loadingDownload = true;
				SignaturesService.getSignatureRequestDocument(
					this.requestId,
					this.authId
				)
					.then((response) => {
						var file = new Blob([response.data], { type: "application/pdf" });
						var fileURL = URL.createObjectURL(file);
						var a = document.createElement("a");
						a.href = fileURL;
						a.download = localStorage.getItem("file_name");
						a.click();
						window.URL.revokeObjectURL(fileURL);
						this.loadingDownload = false;
					})
					.catch((error) => {
						console.log(error);
						this.loadingDownload = false;
					});
			}
		},

        downloadReqEvidencesDocument() {
                    if (this.transactionId) {
                        this.loadingDownload = true;
                        SignaturesService.getReqEvidencesDocument(
                            this.requestId,
                            this.authId
                        )
                            .then((response) => {
                                var file = new Blob([response.data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                var a = document.createElement("a");
                                a.href = fileURL;
                                a.download = localStorage.getItem("file_name");
                                a.click();
                                window.URL.revokeObjectURL(fileURL);
                                this.loadingDownload = false;
                            })
                            .catch((error) => {
                                console.log(error);
                                this.loadingDownload = false;
                            });
                    }
                },

		getIconColorByStatus(type) {
			let color = "";
			switch (type) {
				case "SIGNED":
					color = "#4CAF50";
					break;

				case "REJECTED":
					color = "#970606";
					break;

				case "NOTIFIED":
					color = "#E0E0E0";
					break;
			}
			return color;
		},
	},
};
</script>

<style scoped>
/* Aseguramos que el alert se comporte como fila y alinee al inicio vertical */
.custom-alert {
  align-items: flex-start; /* equivalente a la clase utilitaria align-start */
}

/* estado firmado: verde oscuro y texto en negrita */
.signed-alert {
  background-color: #2E7D32 !important; /* verde más oscuro */
  color: #FFFFFF !important;            /* texto blanco */
  border: none !important;
  box-shadow: none !important;
  /*font-weight: 700 !important;          negrita */
}

/* asegurar que el contenido interno de v-alert use negrita y blanco */
.signed-alert .v-alert__content,
.signed-alert .v-icon,
.signed-alert .v-btn__content {
  color: #FFFFFF !important;
  font-weight: 700 !important;
}

/* icono: más visible y alineado */
.signed-alert__icon {
  margin-right: 8px;
  font-size: 20px;       /* sube a 22px si quieres más presencia */
  color: #FFFFFF !important;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;
}

/* Si Vuetify envuelve el prepend en un contenedor, obligamos a que no se centre */
.custom-alert .v-alert__prepend {
  align-self: flex-start;
  margin-right: 12px; /* separación entre icono y texto */
  display: flex;
  align-items: flex-start;
}

/* El icono en sí: tamaño controlado y alineación superior */
.custom-alert-icon {
  width: 40px;           /* ajusta al tamaño que necesites */
  height: 40px;
  object-fit: contain;
  display: block;
  align-self: flex-start; /* fuerza que la imagen se alinee arriba de la caja */
  margin-top: 2px;       /* pequeño ajuste para "pegar" exactamente con la primera línea */
}

/* Contenedor de texto: evitar que el contenido se centre verticalmente */
.custom-alert-content {
  display: block;
  line-height: 1.25;     /* ajusta si necesitas más/menos separación entre líneas */
  margin: 0;
}

/* Si quieres que el link no provoque desplazamientos, lo mantenemos inline */
.custom-alert-link {
  margin: 4px 0 0 0;
  padding: 0;
}

/* --- estilos homogéneos para las alertas incluidas en el card --- */
.alerts-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* alerta homogénea: mismo fondo/texto que custom-alert, sin marco */
.homogeneous-alert {
  width: 100%;
  border: none !important;
  box-shadow: none !important;
  /* ahora toma el fondo y el color desde variables CSS */
  background-color: var(--hom-bg, transparent) !important;
  color: var(--hom-txt, inherit) !important;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 8px 12px;
}

/* asegurar que el icono herede el color correcto */
.homogeneous-alert .v-icon {
  color: inherit !important;
  margin-right: 8px;
}

/* cuando el v-alert usa la propiedad "text", el contenido está en .v-alert__content */
.homogeneous-alert .v-alert__content {
  color: inherit !important;
  padding: 0;
}

/* pequeño ajuste para separar alertas */
.homogeneous-alert.mt-2 { margin-top: 8px; }

/* separa el botón de las alertas que vienen debajo */
.download-btn {
  margin-bottom: 18px; /* aumenta espacio abajo del botón */
}

/* opción adicional: más separación arriba de las alertas */
.homogeneous-alert.mt-2 {
  margin-top: 18px; /* controla separación entre botón y alertas cuando ambas se muestran */
}

/* ===== Ajuste: menos separación horizontal entre icono y texto ===== */
.signer-item {
  display: flex !important;
  align-items: flex-start !important;
  gap: 2px;                /* reducido desde 12px */
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.signer-action {
  display: flex !important;
  align-items: flex-start !important;
  align-self: flex-start !important;
  min-width: 32px;         /* reducido ligeramente si cabe */
  margin-right: 2px;       /* reducido desde 8px */
  padding: 0 !important;
}

.signer-icon {
  font-size: 20px !important; /* deja el icono ligeramente más compacto */
  line-height: 1 !important;
  display: block !important;
  vertical-align: top !important;
  margin-top: 0 !important;
  color: #2E7D32;
}


/* Si el icono es un <img> (ejemplo en custom-alert), aplica lo mismo */
.signer-action img,
.signer-action svg {
  display: block !important;
  vertical-align: top !important;
  margin-top: 0 !important;
}

/* Contenido: permitir wrap y ocupar resto de espacio */
.signer-content {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
}

/* Metadatos */
.signer-name { margin: 0 0 4px 0; line-height: 1.2; }
.signer-meta, .signer-comments { margin: 0; font-size: 0.95rem; color: rgba(0,0,0,0.65); }

/* --- AJUSTE FINO: si visualmente el icono queda aún 1-2px abajo, usa transform/translateY */
/* Descomenta y ajusta el valor (por ejemplo -1px o -2px) si lo necesitas */
.signer-icon--nudge {
  /* transform: translateY(-1px); */
  /* o usar top con position relative:
  position: relative;
  top: -1px;
  */
}

/* reject-alert: mismo estilo pero fondo rojo y icono de cierre */
.reject-alert {
  background-color: #970606 !important; /* rojo oscuro (ajusta si prefieres otro) */
  color: #FFFFFF !important;
  border: none !important;
  box-shadow: none !important;
  /*font-weight: 700 !important;*/
}
.reject-alert .v-alert__content,
.reject-alert .v-icon { color: #FFFFFF !important; font-weight: 700 !important; }
.reject-alert__icon { margin-right: 8px; font-size: 20px; color: #FFFFFF !important; }


</style>
